import React, { useEffect } from 'react';

interface IntroAnimationProps {
  onComplete: () => void;
}

const IntroAnimation: React.FC<IntroAnimationProps> = ({ onComplete }) => {
  useEffect(() => {
    // Keep the 2 second total duration
    const timer = setTimeout(onComplete, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black animate-fade-out">
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeOut {
          from {
            opacity: 1;
          }
          to {
            opacity: 0;
          }
        }

        .animate-fade-in-up {
          opacity: 0;
          animation: fadeInUp 0.6s ease-out forwards;
        }

        .animate-fade-out {
          animation: fadeOut 0.5s ease-out forwards;
          animation-delay: 2s;
        }

        .delay-0 { animation-delay: 0s; }
        .delay-1 { animation-delay: 0.2s; }
        .delay-2 { animation-delay: 0.4s; }
      `}</style>

      <img 
        src="/app-icon.svg" 
        alt="Fight Vision Logo" 
        className="w-20 h-20 animate-fade-in-up delay-0"
      />
      
      <h1 className="text-2xl font-bold text-white tracking-tight mt-6 animate-fade-in-up delay-1">
        fightvision
      </h1>
      
      <p className="mt-4 text-white animate-fade-in-up delay-2">
        Predicting UFC fights with machine learning
      </p>
    </div>
  );
};

export default IntroAnimation; 